import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Prompt } from '../../../Types';

export interface PromptState {
    prompts: Prompt[];
    basePrompt?: Prompt;
    visionPrompt?: Prompt;
    selectedPrompt?: Prompt;
    combinedPrompts?: Prompt[];
}

const initialState: PromptState = {
    prompts: [],
    basePrompt: undefined,
    visionPrompt: undefined,
    selectedPrompt: undefined,
    combinedPrompts: [],
};

const promptSlice = createSlice({
    name: 'prompt',
    initialState,
    reducers: {
        setPrompts: (state, action: PayloadAction<Prompt[]>) => {
            state.prompts = action.payload;
        },
        setBasePrompt: (state, action: PayloadAction<Prompt>) => {
            state.basePrompt = action.payload;
        },
        setVisionPrompt: (state, action: PayloadAction<Prompt>) => {
            state.visionPrompt = action.payload;
        },
        setSelectedPrompt: (state, action: PayloadAction<Prompt>) => {
            state.selectedPrompt = action.payload;
        },
        setCombinedPrompts: (state, action: PayloadAction<Prompt[]>) => {
            state.combinedPrompts = action.payload;
        },
    },
});

export const { setPrompts, setBasePrompt, setVisionPrompt, setSelectedPrompt, setCombinedPrompts } =
    promptSlice.actions;
export default promptSlice.reducer;
